module.exports = __webpack_public_path__ + "icons/ppLogo.edf6a9f2029c9a375fcd03533e813d12.svg";